import { render, staticRenderFns } from "./table_config_tableinfo.vue?vue&type=template&id=77587069&scoped=true"
import script from "./table_config_tableinfo.vue?vue&type=script&lang=js"
export * from "./table_config_tableinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77587069",
  null
  
)

export default component.exports